import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import "./App.scss";
import { AppFooter } from "./Components/AppFooter";
import { AppHeader } from "./Components/AppHeader";
import PopupContainer from "./Components/PopupContainer";
import { ScrollToTop } from "./Components/ScrollToTop";
import { useAnalytics } from "./hooks/useAnalytics";
import { appRoutes, NotFound } from "./routes";
import { getLangFromPath } from "./utils/seoConfig";

// Jezik se određuje isključivo iz URL-a ("/de/..." = nemački), da bi Google
// mogao da indeksira obe jezičke verzije kao zasebne stranice.
const LanguageFromUrl = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = getLangFromPath(pathname);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return null;
};

const withLayout = (element, bare) =>
  bare ? (
    element
  ) : (
    <>
      <AppHeader />
      {element}
      <AppFooter />
    </>
  );

const AppContent = () => {
  useAnalytics();

  return (
    <>
      <LanguageFromUrl />
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          {["", "/de"].flatMap((prefix) =>
            appRoutes.map(({ path, Component, bare }) => {
              const fullPath =
                path === "/" ? prefix || "/" : `${prefix}${path}`;
              return (
                <Route
                  key={fullPath}
                  path={fullPath}
                  element={withLayout(<Component />, bare)}
                />
              );
            })
          )}
          <Route path="*" element={withLayout(<NotFound />)} />
        </Routes>
      </Suspense>
      <PopupContainer />
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
};

export default App;
